import React from "react";
import { SignIn, SignUp } from "@clerk/react";
import { Logo } from "../components/Shell";

const Panel = () => (
  <div className="hidden flex-col items-center justify-center bg-[var(--navy)] p-12 text-center text-white lg:flex">
    <Logo className="h-40 max-w-[260px] object-contain" />
    <h1 className="mt-6 text-5xl font-extrabold leading-none">Closed preview access</h1>
    <p className="mx-auto mt-4 max-w-sm text-sm text-[var(--steel)]">Accounts get access only after Verge operations has invited the email address. Synthetic data only.</p>
  </div>
);

export function SignInPage() {
  return (
    <div className="auth-grid grid lg:grid-cols-2">
      <Panel />
      <div className="flex items-center justify-center px-4 py-10" data-testid="sign-in-page">
        <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
      </div>
    </div>
  );
}

export function SignUpPage() {
  return (
    <div className="auth-grid grid lg:grid-cols-2">
      <Panel />
      <div className="flex flex-col items-center justify-center gap-4 px-4 py-10" data-testid="sign-up-page">
        <p className="max-w-sm text-center text-sm text-[var(--muted)]" data-testid="sign-up-invite-notice">Use the exact email Verge invited. Uninvited accounts stay without access.</p>
        <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
      </div>
    </div>
  );
}
